import { GameSettings } from "./types";
import { contentTypeIds } from "../types";

export const squadbusters: GameSettings = {
  enabledTabs: ["news", "community", "blog"],
  enabledLocales: [
    "en",
    "fr",
    "de",
    "it",
    "ja",
    "ko",
    "pl",
    "pt",
    "ru",
    "es",
    "tr",
    "zh",
    "zh-hans",
  ],
  enabledNotificationTypes: ["standard"],
  referenceWidth: 850,
  availableButtonVariants: ["yellow", "blue", "green", "twitch", "red", "pink"],
  progressBarDefaultColor: "#FE41FD",
  availableCategories: [
    {
      id: "news",
      name: {
        en: "News",
        fr: "Nouveautés",
        de: "News",
        it: "Notizie",
        ja: "新着",
        ko: "뉴스",
        pl: "Aktualności",
        pt: "Notícias",
        ru: "Новости",
        es: "Novedades",
        tr: "Haberler",
        zh: "最新情報",
      },
      color: "#F7DB1C",
    },
    {
      id: "community",
      name: {
        en: "Community",
        fr: "Communauté",
        de: "Community",
        it: "Community",
        ja: "コミュニティ",
        ko: "커뮤니티",
        pl: "Wspólnota",
        pt: "Comunidade",
        ru: "Сообщество",
        es: "Comunidad",
        tr: "Topluluk",
        zh: "社群",
      },
      color: "#00E2FD",
    },
    {
      id: "community-event",
      name: {
        en: "Community Event",
        fr: "Événement communautaire",
        de: "Community-Ereignis",
        it: "Evento della community",
        ja: "コミュニティイベント",
        ko: "커뮤니티 이벤트",
        pl: "Wydarzenie społecznościowe",
        pt: "Evento da comunidade",
        ru: "Событие сообщества",
        es: "Evento de la comunidad",
        tr: "Topluluk Etkinliği",
        zh: "社群活動",
      },
      color: "#BC52EA",
    },
    {
      id: "video",
      name: {
        en: "Video",
        fr: "Video",
        de: "Video",
        it: "Video",
        ja: "ビデオ",
        ko: "동영상",
        pl: "Video",
        pt: "Video",
        ru: "видео",
        es: "Video",
        tr: "Video",
        zh: "動畫",
      },
      color: "#2D85F3",
    },
    {
      id: "game-update",
      name: {
        en: "Game Updates",
        fr: "Mises à jour",
        de: "Updates",
        it: "Aggiornamenti",
        ja: "アップデート",
        ko: "업데이트",
        pl: "Aktualizacje gry",
        pt: "Novidades do jogo",
        ru: "Обновления",
        es: "Actualizaciones",
        tr: "Oyun Güncellemeleri",
        zh: "更新說明",
      },
      color: "#FF6FE5",
    },
  ],

  enabledComposePages: ["news", "events"],

  resolutions: {
    [contentTypeIds.newsEntryArticle]: {
      heroImage: {
        width: 1600,
        height: 443,
      },
      largeThumbnail: {
        width: 1920,
        height: 1080,
      },

      websiteHeroImage: null,
    },
    [contentTypeIds.newsEntryExternalLink]: {
      linkThumbnail: {
        width: 1920,
        height: 1080,
      },
    },
    [contentTypeIds.videoBlock]: {
      videoThumbnail: {
        width: 960,
        height: 540,
      },
    },
    [contentTypeIds.newsEntryVideo]: {
      videoThumbnail: {
        width: 1920,
        height: 1080,
      },
    },
    [contentTypeIds.imageBlock]: {
      image: null,
    },
    [contentTypeIds.featureBlock]: {
      featureThumbnail: {
        width: 300,
        height: 300,
        fit: "pad",
      },
    },
    [contentTypeIds.carouselEventEntry]: {
      carouselImage: {
        width: 860,
        height: 1080,
      },
    },

    [contentTypeIds.communityCreator]: {
      communityCreatorThumbnail: {
        width: 50,
        height: 50,
      },
    },

    [contentTypeIds.communityVideoEntry]: {
      communityEntryVideoThumbnail: {
        width: 1280,
        height: 720,
      },
    },

    [contentTypeIds.communityLivestreamEntry]: {
      livestreamEntryVideoThumbnail: {
        width: 1280,
        height: 720,
      },
    },

    [contentTypeIds.carouselEventProgressTrackerEntry]: {
      carouselImage: {
        width: 860,
        height: 1080,
      },
      milestone1Image: {
        width: 256,
        height: 256,
      },
      milestone2Image: {
        width: 256,
        height: 256,
      },
      milestone3Image: {
        width: 256,
        height: 256,
      },
      milestone4Image: {
        width: 256,
        height: 256,
      },
      milestone5Image: {
        width: 256,
        height: 256,
      },
      milestone6Image: {
        width: 256,
        height: 256,
      },
      milestone7Image: {
        width: 256,
        height: 256,
      },
      milestone8Image: {
        width: 256,
        height: 256,
      },
    },

    [contentTypeIds.carouselEventPollEntry]: {
      carouselImage: {
        width: 860,
        height: 1080,
      },
      option1Image: {
        width: 560,
        height: 640,
      },
      option2Image: {
        width: 560,
        height: 640,
      },
      option3Image: {
        width: 560,
        height: 640,
      },
      option4Image: {
        width: 560,
        height: 640,
      },
      option5Image: {
        width: 560,
        height: 640,
      },
    },

    [contentTypeIds.pollBlock]: {
      option1Image: {
        width: 560,
        height: 640,
      },
      option2Image: {
        width: 560,
        height: 640,
      },
      option3Image: {
        width: 560,
        height: 640,
      },
      option4Image: {
        width: 560,
        height: 640,
      },
      option5Image: {
        width: 560,
        height: 640,
      },
    },

    [contentTypeIds.newsEntryImage]: {
      imageNewsThumbnail: {
        width: 1920,
        height: 1080,
      },
    },

    [contentTypeIds.fullscreenEntryCarousel]: {
      backgroundMedia: {
        width: 1620,
        height: 1080,
      },
    },

    [contentTypeIds.webEvent]: {
      backgroundImage: {
        width: 1920,
        height: 1080,
      },
    },
  },
  targetingFields: [
    "country",
    "countryExclude",
    "platform",
    "hideFromYoungPlayer",
    "campaignId",
  ],
  preRegBlogSyncEnabled: true,
  supportProgressTrackerEntry: true,
  supportPolls: true,
  supportTargetPolls: false,
  ingameProgressTrackersEnabled: true,
  leaderboardEnabled: true,
};
